import { v4 as uuidv4 } from "uuid";

let correlationId = localStorage.getItem("correlationId");

export const getCorrelationId = () => {
  if (!correlationId) {
    correlationId = uuidv4();
    localStorage.setItem("correlationId", correlationId);
  }
  return correlationId;
};
